<div class="body-container">
  <mat-toolbar color="primary" class="toolbar">
    <mat-toolbar-row class="toolbar-row">

      @if (!isEmbed) {
        <button type="button" class="brand" (click)="goHome()">WebShark</button>
      }
      @if (captureFile) {
        <button
          mat-raised-button
          class="capture-file"
          [matTooltip]="captureFile"
          (click)="downloadCapture()"
          >
          <mat-icon class="mat-18">download</mat-icon>
          <span class="capture-file-name">{{ captureFile }}</span>
        </button>
      }
      @if (!isEmbed) {
        <flexible-chart
          chart
          class="toolbar-chart"
          [typeOfChart]="typeOfChart"
          (range)="webShark.range = $event"
          [data]="chartSeries"
          #headerChart
        ></flexible-chart>
      }
      @if (canShare) {
        <button mat-button class="share-btn" (click)="copyShareLink()">Share</button>
      }
      @if (!isEmbed) {
        <button
          mat-icon-button
          [matTooltip]="theme.tooltip"
          (click)="theme.cycle()"
          >
          <mat-icon>{{ theme.icon }}</mat-icon>
        </button>
      }
      @if (!isEmbed) {
        <button mat-icon-button [matMenuTriggerFor]="menuSettings">
          <mat-icon>settings</mat-icon>
          <mat-menu #menuSettings="matMenu">
            <div>
              <div class="theme-menu" (click)="$event.stopPropagation()">
                <div class="theme-menu-label">Appearance</div>
                <mat-radio-group
                  class="theme-menu-options"
                  [value]="theme.mode"
                  (change)="theme.setMode($event.value)"
                  >
                  <mat-radio-button color="primary" value="auto">Auto</mat-radio-button>
                  <mat-radio-button color="primary" value="light">Light</mat-radio-button>
                  <mat-radio-button color="primary" value="dark">Dark</mat-radio-button>
                </mat-radio-group>
              </div>
              <div style="padding: 1rem; display: flex">
                <mat-radio-group aria-label="Chart settings">
                  <mat-radio-button
                    color="primary"
                    (click)="typeOfChart = 'line'"
                    value="line"
                    >Line</mat-radio-button
                    >
                    <mat-radio-button
                      color="primary"
                      (click)="typeOfChart = 'bar'"
                      value="bar"
                      >Bar</mat-radio-button
                      >
                      <mat-radio-button
                        color="primary"
                        (click)="typeOfChart = 'area'"
                        value="area"
                        checked
                        >Area</mat-radio-button
                        >
                      </mat-radio-group>
                    </div>
                    <div
              style="
                padding: 0rem;
                padding-bottom: 1rem;
                width: 390px;
                display: flex;
                justify-content: space-around;
              "
                      >
                      <button
                        mat-button
                        (click)="framePosition = ['vertical', 'horizontal']"
                        >
                        <div style="width: 60px; height: 60px; padding-top: 5px">
                          <mat-grid-list cols="2" rowHeight="25px">
                            <mat-grid-tile
                              [colspan]="2"
                              class="grid-content"
                            ></mat-grid-tile>
                            <mat-grid-tile class="grid-content"></mat-grid-tile>
                            <mat-grid-tile class="grid-content"></mat-grid-tile>
                          </mat-grid-list>
                        </div>
                      </button>
                      <button
                        mat-button
                        (click)="framePosition = ['horizontal', 'vertical']"
                        >
                        <div style="width: 60px; height: 60px; padding-top: 5px">
                          <mat-grid-list cols="2" rowHeight="25px">
                            <mat-grid-tile
                              [rowspan]="2"
                              class="grid-content"
                            ></mat-grid-tile>
                            <mat-grid-tile class="grid-content"></mat-grid-tile>
                            <mat-grid-tile class="grid-content"></mat-grid-tile>
                          </mat-grid-list>
                        </div>
                      </button>
                      <button
                        mat-button
                        (click)="framePosition = ['horizontal', 'horizontal']"
                        >
                        <div style="width: 60px; height: 60px; padding-top: 5px">
                          <mat-grid-list cols="3" rowHeight="50px">
                            <mat-grid-tile class="grid-content"></mat-grid-tile>
                            <mat-grid-tile class="grid-content"></mat-grid-tile>
                            <mat-grid-tile class="grid-content"></mat-grid-tile>
                          </mat-grid-list>
                        </div>
                      </button>
                      <button
                        mat-button
                        (click)="framePosition = ['vertical', 'vertical']"
                        >
                        <div style="width: 60px; height: 60px; padding-top: 5px">
                          <mat-grid-list cols="1" rowHeight="16px">
                            <mat-grid-tile class="grid-content"></mat-grid-tile>
                            <mat-grid-tile class="grid-content"></mat-grid-tile>
                            <mat-grid-tile class="grid-content"></mat-grid-tile>
                          </mat-grid-list>
                        </div>
                      </button>
                    </div>
                  </div>
                </mat-menu>
              </button>
            }
          </mat-toolbar-row>
        </mat-toolbar>
        <mat-drawer-container class="example-container" autosize>
          <mat-drawer #drawer class="example-sidenav" mode="side" [opened]="false">
            @if (!isKIOSK && !isClientOnly) {
              <app-files-page [isFile]="!isFileOnLink"></app-files-page>
            }
          </mat-drawer>
          <div class="example-sidenav-content">
            <app-webshark
              [fileList]="files"
              [framePosition]="framePosition"
              (ready)="onChartReady($event)"
              #webShark
            ></app-webshark>
          </div>
        </mat-drawer-container>
      </div>

      @for (dialog of dialogs; track dialog; let idx = $index) {
        <modal-resizable
          [title]="dialog.name || tapPage.title || '. . .'"
          (close)="onClose(idx)"
          >
          <tap-page [taplink]="dialog.link" #tapPage></tap-page>
        </modal-resizable>
      }
